import { makeBinding } from './baseBinding'
import { BrandPage } from '../pages/Brand/Brand'
import { getFeatureFlag } from '../hooks/useFeatureFlag'

const selector = '[data-react-bind="band-home"]'
export const autoBindBrandHome = makeBinding(() => [
  getFeatureFlag('newcampaigns'),
  document.querySelectorAll(selector),
  <BrandPage />,
])
